import { Component, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { MessagesService } from '@core/_services/messages.service';

@Component({
    selector: 'movedocs',
    templateUrl: 'movedocs.component.html',
    styleUrls: ['movedocs.component.scss'],
})
export class MoveDocsComponent implements OnInit, OnChanges {
    @Input() public currentAction;
    @Input() public bskMode;
    @Input() public currentSelectedBsk;
    @Input() public basketMoveAll;
    @Input() public dialogMode = true;
    @Input() public atfName = '';    
    @Input() public docId = ''; 
    @Input() public actionGroup; 

    @Input()
    @Output()
    public visible: boolean;
    @Output()
    public onClose: EventEmitter<any> = new EventEmitter();

    @Output()
    public onSelectBasketTransfert: EventEmitter<any> = new EventEmitter();

    public fr: any;
    public error = false;

    constructor(protected _messageService: MessagesService) {}

    public ngOnInit() {
        if (this.actionGroup === true) {
            this.docId = '';
            this.atfName = '';
        }
    }

    public ngOnChanges() {}

    public selectBasketTransfert($event) {        
        this.onSelectBasketTransfert.emit($event.data);
        this.close('transfert');
    }
   
    public selectBasketTransfertImg($event) {  
        this.onSelectBasketTransfert.emit($event);
    }

    public close(event) {
        this.visible = false;
        this.onClose.emit(event);
    }
}
